import useApi from '../hooks/useApi';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useTradeConfirmationService = () => {
  const { request } = useApi();

  const updateTradeConfirmation = async (tradeConfirmation, currentSettings) => {
    try {
      // Update settings with new trade confirmation value, preserving other settings
      const response = await request(`${BACKEND_URL}/auth/settings`, {}, 'PUT', {
        maxLossPerDay: currentSettings.maxLossPerDay || 0,
        maxLossPerDayEnabled: currentSettings.maxLossPerDayEnabled || false,
        // Send as old parameter names for backward compatibility with backend
        maxLossPerTrade: currentSettings.maxLossPerPosition || 0,
        maxLossPerTradeEnabled: currentSettings.maxLossPerPositionEnabled || false,
        tradeConfirmation,
        showTooltips: currentSettings.showTooltips !== false
      });
      
      return response; // Return the full response instead of just tradeConfirmation
    } catch (error) {
      console.error('Error updating trade confirmation setting:', error);
      throw error;
    }
  };

  return {
    updateTradeConfirmation
  };
}; 